import Button from "components/shared/Button";
import styled from "styled-components";

export const LinkButton = styled(Button)`
    text-decoration: none;
`;